import React from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  style?: React.CSSProperties;
  titleClassName?: string;
  subtitleClassName?: string;
}

/**
 * Componente reutilizable para títulos de página
 * Reemplaza el patrón repetido de:
 * <div className="page-title">
 *   <div className="container">
 *     <h2 className="ipt-title">...</h2>
 *     <span className="ipn-subtitle">...</span>
 *   </div>
 * </div>
 */
export default function PageTitle({
  title,
  subtitle,
  style,
  titleClassName = '',
  subtitleClassName = ''
}: PageTitleProps) {
  return (
    <div className="page-title" style={style}>
      <div className="container">
        <h2 className={`ipt-title ${titleClassName}`}>{title}</h2>
        {subtitle && (
          <span className={`ipn-subtitle ${subtitleClassName}`}>{subtitle}</span>
        )}
      </div>
    </div>
  );
}
